import { useEffect, useState } from "react";
import api, { fmtCurrency, fmtDate } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Textarea } from "../components/ui/textarea";
import { Plus, Check, Trash2, CalendarClock, ArrowDownRight, ArrowUpRight } from "lucide-react";

export default function Payments() {
  const [rows, setRows] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [accs, setAccs] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty());
  const [filter, setFilter] = useState("beklemede");
  function empty() { return { type: "odeme", amount: "", currency: "TRY", due_date: new Date().toISOString().slice(0, 10), contact_id: "", account_id: "", description: "", status: "beklemede" }; }

  const load = async () => {
    const [p, c, a] = await Promise.all([api.get("/payments"), api.get("/contacts"), api.get("/accounts")]);
    setRows(p.data); setContacts(c.data); setAccs(a.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/payments", { ...form, amount: parseFloat(form.amount), contact_id: form.contact_id || null, account_id: form.account_id || null });
      toast.success("Kaydedildi"); setOpen(false); setForm(empty()); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };

  const complete = async (id) => {
    await api.post(`/payments/${id}/complete`);
    toast.success("İşlem tamamlandı ve kaydedildi"); load();
  };
  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/payments/${id}`); toast.success("Silindi"); load();
  };

  const filtered = rows.filter((r) => filter === "all" || r.status === filter);

  return (
    <div className="space-y-5 nf-fade-up">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest font-mono-num text-slate-500">PLANLAMA</div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">Yaklaşan Ödemeler & Tahsilatlar</h1>
        </div>
        <div className="flex gap-2">
          <div className="flex gap-1 p-1 bg-slate-900/60 rounded-lg border border-slate-800">
            {[["beklemede", "Bekliyor"], ["tamamlandi", "Tamamlanan"], ["all", "Tümü"]].map(([v, l]) => (
              <button key={v} onClick={() => setFilter(v)}
                className={`px-3 py-1.5 text-xs rounded-md font-medium ${filter === v ? "bg-cyan-500/15 text-cyan-300" : "text-slate-400 hover:text-slate-200"}`}>{l}</button>
            ))}
          </div>
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="add-payment-btn" className="bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold"><Plus className="w-4 h-4 mr-1.5" /> Yeni Kayıt</Button></DialogTrigger>
            <DialogContent className="bg-[#121722] border-slate-800">
              <DialogHeader><DialogTitle className="font-head">Yeni Ödeme/Tahsilat</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <div><Label>Açıklama</Label><Textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Tür</Label>
                    <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                      <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue /></SelectTrigger>
                      <SelectContent><SelectItem value="odeme">Ödeme</SelectItem><SelectItem value="tahsilat">Tahsilat</SelectItem></SelectContent>
                    </Select>
                  </div>
                  <div><Label>Vade Tarihi</Label><Input type="date" value={form.due_date} onChange={(e) => setForm({ ...form, due_date: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Tutar</Label><Input type="number" step="0.01" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="bg-slate-900/60 border-slate-800 mt-1" /></div>
                  <div><Label>Döviz</Label>
                    <Select value={form.currency} onValueChange={(v) => setForm({ ...form, currency: v })}>
                      <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue /></SelectTrigger>
                      <SelectContent>{["TRY", "USD", "EUR"].map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                    </Select>
                  </div>
                </div>
                <div><Label>Cari</Label>
                  <Select value={form.contact_id || "none"} onValueChange={(v) => setForm({ ...form, contact_id: v === "none" ? "" : v })}>
                    <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue placeholder="Seçiniz" /></SelectTrigger>
                    <SelectContent><SelectItem value="none">Yok</SelectItem>{contacts.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <div><Label>Hesap</Label>
                  <Select value={form.account_id || "none"} onValueChange={(v) => setForm({ ...form, account_id: v === "none" ? "" : v })}>
                    <SelectTrigger className="bg-slate-900/60 border-slate-800 mt-1"><SelectValue placeholder="Seçiniz" /></SelectTrigger>
                    <SelectContent><SelectItem value="none">Yok</SelectItem>{accs.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}</SelectContent>
                  </Select>
                </div>
                <Button onClick={save} className="w-full bg-gradient-to-r from-cyan-500 to-emerald-500 text-slate-950 font-semibold">Kaydet</Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        {filtered.length === 0 && <div className="text-slate-500 text-sm col-span-2 nf-card p-10 text-center">Kayıt yok</div>}
        {filtered.map((p) => {
          const dueDate = new Date(p.due_date);
          const days = Math.ceil((dueDate - new Date()) / (1000 * 60 * 60 * 24));
          const overdue = days < 0 && p.status === "beklemede";
          const soon = days <= 3 && days >= 0 && p.status === "beklemede";
          return (
            <div key={p.id} className="nf-card p-5 relative">
              {overdue && <div className="absolute top-3 right-3 nf-chip border-rose-500/30 bg-rose-500/10 text-rose-400">GECİKMİŞ</div>}
              {soon && !overdue && <div className="absolute top-3 right-3 nf-chip border-amber-500/30 bg-amber-500/10 text-amber-400">YAKLAŞIYOR</div>}
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center`} style={{ background: p.type === "tahsilat" ? "rgba(16,185,129,0.1)" : "rgba(244,63,94,0.1)" }}>
                  {p.type === "tahsilat" ? <ArrowDownRight className="w-5 h-5 text-emerald-400" /> : <ArrowUpRight className="w-5 h-5" style={{ color: "#F43F5E" }} />}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-head font-bold truncate pr-20">{p.description}</div>
                  <div className="flex items-center gap-3 mt-1 text-[11px] uppercase tracking-widest font-mono-num text-slate-500">
                    <span className="flex items-center gap-1"><CalendarClock className="w-3 h-3" /> {fmtDate(p.due_date)}</span>
                    <span>•</span>
                    <span>{p.type === "tahsilat" ? "TAHSİLAT" : "ÖDEME"}</span>
                  </div>
                  <div className="mt-3 font-head font-extrabold text-2xl font-mono-num" style={{ color: p.type === "tahsilat" ? "#10B981" : "#F43F5E" }}>
                    {p.type === "tahsilat" ? "+" : "−"}{fmtCurrency(p.amount, p.currency)}
                  </div>
                </div>
              </div>
              {p.status === "beklemede" && (
                <div className="mt-4 pt-4 border-t border-slate-800/60 flex gap-2">
                  <Button data-testid={`complete-payment-${p.id}`} onClick={() => complete(p.id)} size="sm" className="bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-300 border border-emerald-500/30"><Check className="w-3.5 h-3.5 mr-1" /> Tamamla</Button>
                  <Button onClick={() => del(p.id)} size="sm" variant="ghost" className="text-slate-500 hover:text-rose-400"><Trash2 className="w-3.5 h-3.5" /></Button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
